import { Button, IconButton, Modal, Paper } from "@mui/material";
import { tint } from "polished";
import { FC } from "react";
import { MdClose } from "react-icons/md";
import styled from "styled-components";
import { IModalProps } from "../../common/interfaces/IModalProps";
import { useInfo } from "../../hooks/useInfo";
import useQuery from "../../utils/useQuery";

const ModalWrapper = styled(Paper)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #4c5667;
  max-width: 500px;
  width: fit-content;
`;

const ModalHeader = styled("div")`
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  border-bottom: 1px solid #e9ecef;
  height: 64px;
  color: ${(props) => props.theme.colors.primary};

  span {
    font-size: 24px;
  }

  .MuiIconButton-root {
    position: absolute;
    right: 4px;
    top: 4px;
  }
`;

const ModalContent = styled("div")`
  .requirements {
    display: flex;
    flex-flow: column;
    padding: 16px;

    h3 {
      margin: 0;
      margin-bottom: 8px;
    }

    strong {
      font-weight: bold;
    }
  }
`;

const AppContentWrapper = styled("div")`
  padding: 8px 16px;
  display: flex;
  flex-flow: column;
  align-items: center;
  border-top: 1px solid #e9ecef;
  gap: 8px;

  p {
    margin: 0;
    font-size: 0.95rem;
    text-align: center;
  }

  span {
    text-align: center;
    font-size: 24px;
    font-weight: 600;
  }

  .MuiButton-root {
    text-transform: none;
    background-color: #2a3142;
    width: fit-content;
    font-family: inherit;
    color: white;
    font-size: 14px;

    &:hover {
      background-color: ${tint(0.2, "#2a3142")};
    }
  }
`;

const HelpModal: FC<IModalProps> = ({ opened = false, handleClose }) => {
  const isWebView = useQuery().get("webview") === "true";

  const { telemedicineData } = useInfo();

  return (
    <Modal open={opened} onClose={handleClose}>
      <ModalWrapper>
        <ModalHeader>
          <span>Ajuda</span>
          <IconButton onClick={handleClose}>
            <MdClose size={22}/>
          </IconButton>
        </ModalHeader>
        <ModalContent>
          <div className="requirements">
            <h3>Requisitos técnicos</h3>
            <span>
              <strong>iPhone e macOS:</strong> Navegador Safari
            </span>
            <span>
              <strong>Android e computadores:</strong> Navegador Google Chrome
            </span>
          </div>
          {!isWebView && !telemedicineData.isWhiteLabel && (
            <AppContentWrapper id="app-content-help">
              <p>
                Caso tenha dificuldades com dispositivos móveis, você pode optar
                baixar o App Amplimed, disponível para Android e iPhone, acessar
                o menu Teleconsulta e inserir o código abaixo:
              </p>
              <span>{telemedicineData.hashedId || ""}</span>
              <Button
                onClick={() => {
                  window.open(
                    "https://ampli.li/app-link-telemedicina-entrar ",
                    "_blank"
                  );
                  handleClose();
                }}
              >
                Baixar o App
              </Button>
            </AppContentWrapper>
          )}
        </ModalContent>
      </ModalWrapper>
    </Modal>
  );
};

export default HelpModal;
